import { render, staticRenderFns } from "./leftImg.vue?vue&type=template&id=1d6c5828&scoped=true&"
var script = {}
import style0 from "./leftImg.vue?vue&type=style&index=0&id=1d6c5828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c5828",
  null
  
)

export default component.exports